import { Component } from '@angular/core';
import { Router } from '@angular/router';
import { TranslateService } from '@ngx-translate/core';
import { SnackbarService } from '@vendasta/galaxy/snackbar-service';
import { combineLatest } from 'rxjs';
import { take } from 'rxjs/operators';
import { LeadQualificationSettingsService } from '../lead-qualification-settings/lead-qualification-settings.service';
import { DupeSettingsViewModel, LeadsDuplicateDetectionService } from '../leads-duplicate-detection.service';

@Component({
  templateUrl: './facebook-settings-page.component.html',
  styleUrls: ['./facebook-settings-page.component.scss'],
})
export class FacebookSettingsPageComponent {
  constructor(
    private readonly snackbarService: SnackbarService,
    private readonly translateService: TranslateService,
    private readonly router: Router,
    private readonly duplicateDetectionService: LeadsDuplicateDetectionService,
    private readonly leadQualificationService: LeadQualificationSettingsService,
  ) {}

  updateDupeCriteria(setting: DupeSettingsViewModel): void {
    this.duplicateDetectionService.updateCriteria(setting);
  }

  saveSettings(): void {
    combineLatest([this.duplicateDetectionService.saveCriteria(), this.leadQualificationService.save()])
      .pipe(take(1))
      .subscribe((_) => {
        this.showSuccess('LEAD_INTEGRATIONS.SETTINGS.COMMON.SAVE_SUCCESS');
        this.router.navigate(['facebook-ad-leads']);
      });
  }

  revertSettings(): void {
    this.duplicateDetectionService.revertCriteria();
  }

  private showSuccess(textKey: string): void {
    this.snackbarService.successSnack(this.translateService.instant(textKey));
  }
}
